import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public sources: { prefix: string; suffix: string }[] = []
  ) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<any> {
    const subscriptions: any = [];
    this.sources.forEach((s) => {
      subscriptions.push(this.http.get(`${s.prefix}${lang}${s.suffix}`));
    });

    return forkJoin(subscriptions).pipe(
      map((translations: any) => {
        const result = {};
        translations.forEach((trans: any) => Object.assign(result, trans));
        return result;
      })
    );
  }
}
